import {useContext} from '@nuxtjs/composition-api';
import {getCompressedBackgroundImage} from '@/core/utils/getCompressedBackgroundImage';

export function useCompressedBackgroundImage() {
    const {$img} = useContext();

    function backgroundImage(path, modifiers) {
        if (!path) {
            return {};
        }

        return getCompressedBackgroundImage({
            $img,
            path,
            modifiers,
        });
    }

    return {
        backgroundImage,
    };
};
